import { Plus, Trash2, Pencil, X } from "lucide-react";
import AdminPageShell from "@/admin/AdminPageShell";
import { useAdminBlogPosts } from "@/admin/useAdminBlogPosts";

const AdminBlog = () => {
  const { posts, editing, loading, openNew, openEdit, close, save, remove, updateEditingField } = useAdminBlogPosts();

  return (
    <AdminPageShell
      title="Blog"
      description="Manage posts, categories, tags and publish status."
      actions={<button onClick={openNew} className="btn-solid-pearl btn-pill-sm" data-testid="admin-blog-new-btn"><Plus size={14} /> New Post</button>}
      testId="admin-blog-page"
    >
      {editing && (
        <form onSubmit={save} className="neu-panel p-6 mb-8 space-y-4" data-testid="admin-blog-form">
          <div className="flex items-center justify-between">
            <span className="eyebrow">{editing.id ? "Edit Post" : "New Post"}</span>
            <button type="button" onClick={close}><X size={18} /></button>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <input required placeholder="Title" value={editing.title} onChange={(e) => updateEditingField("title", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-blog-title-input" />
            <input required placeholder="Slug (url-friendly)" value={editing.slug} onChange={(e) => updateEditingField("slug", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-blog-slug-input" />
          </div>
          <textarea required placeholder="Excerpt" value={editing.excerpt} onChange={(e) => updateEditingField("excerpt", e.target.value)} className="neu-inset w-full p-3" rows={2} data-testid="admin-blog-excerpt-input" />
          <textarea required placeholder="Content" value={editing.content} onChange={(e) => updateEditingField("content", e.target.value)} className="neu-inset w-full p-3" rows={6} data-testid="admin-blog-content-input" />
          <div className="grid sm:grid-cols-2 gap-4">
            <input placeholder="Cover image URL" value={editing.cover_image || ""} onChange={(e) => updateEditingField("cover_image", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-blog-cover-input" />
            <input placeholder="Category" value={editing.category || ""} onChange={(e) => updateEditingField("category", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-blog-category-input" />
          </div>
          <input placeholder="Tags (comma separated)" value={editing.tags} onChange={(e) => updateEditingField("tags", e.target.value)} className="neu-inset w-full h-11 px-3" data-testid="admin-blog-tags-input" />
          <div className="flex items-center gap-6">
            <select value={editing.status} onChange={(e) => updateEditingField("status", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-blog-status-select">
              <option value="draft">Draft</option>
              <option value="published">Published</option>
            </select>
            <label className="flex items-center gap-2 text-small">
              <input type="checkbox" checked={editing.featured} onChange={(e) => updateEditingField("featured", e.target.checked)} data-testid="admin-blog-featured-checkbox" /> Featured
            </label>
          </div>
          <button type="submit" className="btn-solid-pearl" data-testid="admin-blog-save-btn">Save Post</button>
        </form>
      )}

      {loading ? (
        <p className="text-small">Loading…</p>
      ) : (
        <div className="space-y-3">
          {posts.map((p) => (
            <div key={p.id} className="neu-surface p-5 flex items-center justify-between gap-4 flex-wrap" data-testid={`admin-blog-row-${p.slug}`}>
              <div>
                <span className="eyebrow" style={{ color: p.status === "published" ? "var(--gg-logo-gold)" : "var(--gg-muted-text)" }}>{p.status}</span>
                <p className="text-body font-semibold mt-1" style={{ color: "var(--gg-ivory)" }}>{p.title}</p>
              </div>
              <div className="flex items-center gap-3">
                <button onClick={() => openEdit(p)} className="btn-outline-silver btn-pill-sm" data-testid={`admin-blog-edit-${p.slug}`}><Pencil size={13} /></button>
                <button onClick={() => remove(p.id)} className="btn-outline-silver btn-pill-sm" data-testid={`admin-blog-delete-${p.slug}`}><Trash2 size={13} /></button>
              </div>
            </div>
          ))}
          {posts.length === 0 && <p className="text-small">No posts yet.</p>}
        </div>
      )}
    </AdminPageShell>
  );
};

export default AdminBlog;
